var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-288 -559) translate(48 279) translate(0 280) translate(240)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C24",
    d: "M12 17.4c-2.844 0-5.147-2.201-5.359-4.991l-3.934-3.04c-.517.648-.993 1.334-1.377 2.084-.174.344-.174.75 0 1.095C3.364 16.516 7.39 19.2 12 19.2c1.01 0 1.983-.15 2.92-.392l-1.945-1.506c-.321.062-.648.095-.975.098zm11.768 2.179l-4.145-3.204c1.259-1.061 2.295-2.363 3.046-3.828.174-.344.174-.75 0-1.094C20.636 7.485 16.61 4.8 12 4.8c-1.93.002-3.83.489-5.524 1.414l-4.77-3.687c-.262-.204-.639-.157-.842.105l-.737.948c-.203.261-.156.638.106.841l22.063 17.053c.262.203.639.156.842-.105l.737-.948c.203-.262.156-.639-.106-.842zm-6.89-5.325l-1.473-1.14c.124-.358.19-.734.195-1.114.026-1.962-1.544-3.574-3.506-3.6-.353-.005-.705.043-1.043.142.226.307.348.677.349 1.058-.006.127-.025.253-.058.375l-2.76-2.133C9.54 7.04 10.75 6.6 12 6.6c2.98-.002 5.398 2.413 5.4 5.394V12c0 .811-.198 1.567-.521 2.254z",
    transform: "translate(-288 -559) translate(48 279) translate(0 280) translate(240)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeSlash);
export default __webpack_public_path__ + "static/media/icon-eye-slash.02eeda28.svg";
export { ForwardRef as ReactComponent };